<ng-container *ngIf="!isCardMode">
  <div class="file-uploader-root">
    <div class="upload-container"
      (dragenter)="onDragEnter($event)"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      [class.dragover]="isDragOver">

      <p-fileUpload [auto]="true" #fileUpload name="file[]" [url]="fileUploadUrl" (onUpload)="onUpload($event)"
        (onBeforeUpload)="onBeforeUpload($event)" (onError)="onUploadError($event)" [accept]="resolvedAccept"
        [headers]="appheaders" [chooseLabel]="uploadButtonLabel" [maxFileSize]="maxSize"
        [invalidFileSizeMessageSummary]="maxSizeMessage" (onSelect)="onFileSelect($event)" chooseIcon="null">
      </p-fileUpload>

      <button type="button" pButton [label]="dropZoneLabel"
        class="drop-zone border-round-lg border-dashed"
        [class.dragover]="isDragOver"
        (click)="onDropZoneClick()">
      </button>

    </div>
  </div>
</ng-container>

<div class="img-upload-card" *ngIf="isCardMode"
  [class.img-upload-card--uploaded]="isImageUploaded"
  [class.img-upload-card--document]="documentMode"
  (dragenter)="onDragEnter($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)">

  <div class="img-upload-hidden-input">
    <p-fileUpload [auto]="true" #fileUpload name="file[]" [url]="fileUploadUrl" (onUpload)="onUpload($event)"
      (onBeforeUpload)="onBeforeUpload($event)" (onError)="onUploadError($event)" [accept]="resolvedAccept"
      [headers]="appheaders" [chooseLabel]="uploadButtonLabel" [maxFileSize]="maxSize"
      [invalidFileSizeMessageSummary]="maxSizeMessage" (onSelect)="onFileSelect($event)" chooseIcon="null">
    </p-fileUpload>
  </div>

  <div class="img-upload-preview-box" [class.img-upload-preview-box--document]="documentMode">
    <img *ngIf="!documentMode" [src]="displayImageUrl"
      (error)="onPreviewImageError($event)"
      alt="" />
    <div *ngIf="documentMode" class="img-upload-doc-placeholder">
      <i class="pi pi-file img-upload-doc-icon"></i>
    </div>
  </div>

  <div class="img-upload-dropzone" *ngIf="!isImageUploaded"
    [class.dragover]="isDragOver"
    (click)="onDropZoneClick()">
    <i class="pi pi-cloud-upload img-upload-cloud-icon"></i>
    <span class="img-upload-drag-title">{{ resolvedDragDropTitle }}</span>
    <div class="img-upload-or-divider"><span>or</span></div>
    <button type="button" pButton class="p-button-outlined img-upload-select-btn"
      [icon]="resolvedSelectButtonIcon"
      [label]="uploadButtonLabel"
      (click)="$event.stopPropagation(); onDropZoneClick()">
    </button>
    <small class="img-upload-hint">{{ fileTypeHint }}</small>
  </div>

  <div class="img-upload-success-panel" *ngIf="isImageUploaded">
    <div class="img-upload-success-header">
      <i class="pi pi-check-circle img-upload-success-icon mr-2"></i>
      <span class="img-upload-success-label">{{ uploadedLabel }}</span>
    </div>
    <div class="img-upload-filename">{{ uploadedFileName || ('label_existing_image' | translate) }}</div>
    <small class="img-upload-filemeta" *ngIf="uploadedFileSize">{{ uploadedFileSize }}</small>
    <div class="img-upload-actions">
      <button type="button" pButton class="p-button-outlined img-upload-change-btn"
        [label]="'label_change_image' | translate"
        (click)="onChangeImageClick()">
      </button>
      <button type="button" pButton class="p-button-outlined p-button-secondary img-upload-remove-btn"
        *ngIf="showRemoveButton"
        [label]="'label_remove' | translate"
        (click)="onRemoveClick()">
      </button>
    </div>
  </div>
</div>
